import { gsap } from "gsap";
import { headerAnimationDataProvider as store } from "./header-animation-data-provider";
// eslint-disable padded-blocks

const headerMobileAnimation = (tl) => {
  if (store.isTablet || store.isMobile) {
    store.setBookingStickyInit(store.elementProps.NAVBAR_ELEMENT_HEIGHT);
    store.setBookingInitial(store.elementProps.NAVBAR_ELEMENT_HEIGHT + 48);

    const bookingBarToStickyTl = gsap.timeline({
      repeat: 0,
      paused: false,
    });
    const bookingBarScrollUpToInitialPositionTl = gsap.timeline({
      repeat: 0,
      paused: false,
    });

    const pinHeight = store.elementProps.BOOKING_ELEMENT_HEIGHT + store.elementProps.NAVBAR_ELEMENT_HEIGHT;
    const destinationNavbarToStickyTl = gsap.timeline({
      id: "mobile-destination-navbar-scroll-tl",
      repeat: 0,
      paused: false,
      scrollTrigger: {
        trigger: store.elements.DESTINATION_NAVBAR_ELEMENT,
        start: `top +${pinHeight}px`,
        endTrigger: "body",
        end: "bottom +200px",
        // pinReparent: true,
        pin: false,
        pinSpacing: false,
        invalidateOnRefresh: true,
        toggleClass: "--sticky",
        onEnter: () => {
          store.setDestinationNavbarState("sticky");
          destinationNavbarToStickyTl.scrollTrigger.refresh();
          // eslint-disable-next-line 
        //  console.log("Mobile here");
        },
        onLeaveBack: () => {
          store.setDestinationNavbarState("initial");
          destinationNavbarToStickyTl.scrollTrigger.refresh();
        },
      },
    });

    const checkAvailabilityToStickyTl = gsap.timeline({
      repeat: 0,
      paused: false,
      scrollTrigger: {
        trigger: store.elements.CHECK_AVAILABILITY_BTN_TRIGGER,
        start: `top +${pinHeight}px`,
        endTrigger: "body",
        end: "bottom +200px",
        // pinReparent: true,
        // pin: true,
        // pinSpacing: false,
        invalidateOnRefresh: true,
        // toggleClass: "--sticky",
        onEnter: () => {
          store.setCheckAvailabilityBtnState("sticky");
          gsap.to(store.elements.CHECK_AVAILABILITY_BTN_ELEMENT, {
            translateY: store.elementProps.NAVBAR_ELEMENT_HEIGHT, // add one pixel for border
            opacity: 1,
          });
        },
        onLeaveBack: () => {
          store.setCheckAvailabilityBtnState("initial");
          gsap.to(store.elements.CHECK_AVAILABILITY_BTN_ELEMENT, {
            translateY: "-200%",
            opacity: 0,
          });
        },
      },
    });

    if (store.hasBookingBar) {
      bookingBarToStickyTl
        .set(store.elements.BOOKING_MOBILE_ELEMENT, {
          position: "fixed",
          maxWidth: "1219px",
          width: "80vw",
          borderRadius: "67px",
          top: store.elementProps.DESTINATION_NAME_ELEMENT_HEIGHT
            ? store.elementProps.DESTINATION_NAME_ELEMENT_HEIGHT
            : store.constants.BOOKING_STICKY_INIT,
          ease: "none",
        })
        .to(
          store.elements.BOOKING_MOBILE_ELEMENT,
          {
            maxWidth: "100%",
            width: "100vw",
            borderRadius: "0",
            top: store.elements.DESTINATION_NAME_ELEMENT_HEIGHT
              ? store.constants.DESTINATION_NAME_ELEMENT_HEIGHT
              : store.constants.BOOKING_STICKY_INIT,

            ease: "none",
          },
          0,
        );

      bookingBarScrollUpToInitialPositionTl.to(
        store.elements.BOOKING_MOBILE_ELEMENT,
        {
          position: "fixed",
          maxWidth: "1219px",
          width: "80vw",
          borderRadius: "67px",
          top: store.constants.BOOKING_INITIAL,
          ease: "none",
        },
        0,
      );
    }

    const navbarToStickyTl = gsap.timeline({
      repeat: 0,
      paused: false,
    });

    const navbarToScrollUpTl = gsap.timeline({
      repeat: 0,
      paused: false,
    });

    const navbarToInitialPosition = gsap.timeline({
      repeat: 0,
      paused: false,
    });

    if (store.hasDestinationMenu) {
      navbarToStickyTl
        .set(store.elements.DESTINATION_NAME_ELEMENT, {
          translateY: "-100%",
          scaleY: "100%",
          minHeight: store.elementProps.NAVBAR_ELEMENT_HEIGHT,
        })
        .to(
          store.elements.DESTINATION_NAME_ELEMENT,
          {
            translateY: "0",
            visibility: "visible",
          },
          0,
        );

      navbarToScrollUpTl.to(
        store.elements.DESTINATION_NAME_ELEMENT,
        {
          translateY: "-100%",
          visibility: "visible",
        },
        0,
      );

      navbarToInitialPosition.to(
        store.elements.DESTINATION_NAME_ELEMENT,
        {
          translateY: "-100%",
        },
        0,
      );
    }

    tl.add(bookingBarToStickyTl, "startToSticky")
      .add(navbarToStickyTl, "startToSticky")
      .add(checkAvailabilityToStickyTl, "startToSticky")
      .add(destinationNavbarToStickyTl, "startToSticky")
      .add(navbarToScrollUpTl, "stickyToScrollUp")
      .add(bookingBarScrollUpToInitialPositionTl, "scrollUpToInitialPosition")
      .add(navbarToInitialPosition, "scrollUpToInitialPosition");

    return tl;
  }

  return null;
};

export default headerMobileAnimation;
